import { AuthProvider } from "@/features/auth";
import { AdminPage } from "./AdminPage";

export function AdminView() {
  return (
    <AuthProvider>
      <AdminPage />
    </AuthProvider>
  );
}
